module.exports = __webpack_public_path__ + "img/new-1.a3c23714.png";